import React from 'react';
import PropTypes from 'prop-types';
import TextFilter from './TextFilter';
import DateFilter from './DateFilter';
import NumberInput from './NumberInput';

const FilterBar = ({
    config,
    inputValue,
    handleInputChange,
    handleInputKeyPress,
    handleSearchClick,
    dateFrom,
    handleDateFromChange,
    toggleDatePicker,
    dateTo,
    handleDateToChange,
    maxRowsInputValue,
    handleMaxRowsChange,
    handleMaxRowsKeyPress,
    totalRows,
    latestUpdate,
    onResetFilters }) => {
    return (
        <div className="filter-container" style={{ backgroundColor: config.color }}>
            <TextFilter
                inputValue={inputValue}
                handleInputChange={handleInputChange}
                handleInputKeyPress={handleInputKeyPress}
                handleSearchClick={handleSearchClick}
            />
            <DateFilter
                selectedDate={dateFrom}
                handleDateChange={handleDateFromChange}
                toggleDatePicker={toggleDatePicker}
                label="From Date"
            />
            <DateFilter
                selectedDate={dateTo}
                handleDateChange={handleDateToChange}
                toggleDatePicker={toggleDatePicker}
                label="To Date"
            />
            <NumberInput
                inputValue={maxRowsInputValue}
                onChange={handleMaxRowsChange}
                onKeyPress={handleMaxRowsKeyPress}
                label="Max Rows"
            />
            {onResetFilters && (
                <div className="filter-item">
                    <button 
                        onClick={onResetFilters}
                        style={{
                            padding: '5px 10px',
                            cursor: 'pointer',
                            backgroundColor: '#f44336',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px'
                        }}
                        title="Reset all dropdown filters to 'All'"
                    >
                        Reset Filters
                    </button>
                </div>
            )}
            <div className="filter-item">
                <label htmlFor="totalRows">Total Rows Found: {totalRows}</label>
            </div>
            <div className="filter-item">
                <label>Last updated: {latestUpdate || "Never"}</label>
            </div>
        </div>
    );
};

FilterBar.propTypes = {
    config: PropTypes.shape({
        color: PropTypes.string.isRequired,
    }).isRequired,
    inputValue: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    handleInputKeyPress: PropTypes.func.isRequired,
    handleSearchClick: PropTypes.func.isRequired,
    dateFrom: PropTypes.instanceOf(Date),
    handleDateFromChange: PropTypes.func.isRequired,
    toggleDatePicker: PropTypes.func,
    dateTo: PropTypes.instanceOf(Date),
    handleDateToChange: PropTypes.func.isRequired,
    maxRowsInputValue: PropTypes.number.isRequired,
    handleMaxRowsChange: PropTypes.func.isRequired,
    handleMaxRowsKeyPress: PropTypes.func.isRequired,
    totalRows: PropTypes.number,
    latestUpdate: PropTypes.string,
    onResetFilters: PropTypes.func,
};

export default FilterBar;